import React, { SVGProps } from 'react';

const ComparePlans = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      data-icon="compare-plans"
      className="icon icon--outline-copy"
      width="44"
      height="44"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={props.fill}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.40381 5.50586C2.40381 2.74444 4.64239 0.505859 7.40381 0.505859H12.6538C15.1019 0.505859 17.1391 2.26529 17.5699 4.58866C19.8657 5.04132 21.5972 7.06551 21.5972 9.4941V18.4941C21.5972 21.2555 19.3586 23.4941 16.5972 23.4941H11.3472C8.89904 23.4941 6.86186 21.7347 6.43111 19.4113C4.13528 18.9586 2.40381 16.9345 2.40381 14.5059V5.50586ZM8.52206 19.5059C8.93719 20.6649 10.0453 21.4941 11.3472 21.4941H16.5972C18.254 21.4941 19.5972 20.151 19.5972 18.4941V9.4941C19.5972 8.20915 18.7893 7.11288 17.6538 6.68548V14.5059C17.6538 17.2673 15.4152 19.5059 12.6538 19.5059H8.52206ZM7.40381 2.50586C5.74695 2.50586 4.40381 3.84901 4.40381 5.50586V14.5059C4.40381 16.1627 5.74695 17.5059 7.40381 17.5059H12.6538C14.3107 17.5059 15.6538 16.1627 15.6538 14.5059V5.50586C15.6538 3.84901 14.3107 2.50586 12.6538 2.50586H7.40381Z"
      />
    </svg>
  );
};

ComparePlans.displayName = 'ComparePlans';

export default ComparePlans;
